import { Slide } from "react-slideshow-image";
import { isWebpSupported } from 'react-image-webp/dist/utils';
import "react-slideshow-image/dist/styles.css";

function GaleriaFotos() {
    const imagesWebp = [
        "../imagens/banner/Image2025-04-14at20.39.16.webp",
        "../imagens/banner/Image2025-04-14at20.39.20.webp",
        "../imagens/banner/Image2025-04-14at20.39.201.webp",
        "../imagens/banner/Image2025-04-14at20.39.202.webp",
        "../imagens/banner/Image2025-04-14at20.39.21.webp",
        "../imagens/banner/Image2025-04-14at20.39.211.webp",
        "../imagens/banner/Image2025-04-14at20.39.22.webp",
        "../imagens/banner/Image2025-04-14at20.39.221.webp",
        "../imagens/banner/Image2025-04-14at20.39.222.webp",
        "../imagens/banner/Image2025-04-14at20.39.23.webp",
        "../imagens/banner/Image2025-04-14at20.39.231.webp",
        "../imagens/banner/Image2025-04-14at20.39.232.webp",
        "../imagens/banner/Image2025-04-14at20.39.233.webp",
        "../imagens/banner/Image2025-04-14at20.39.24.webp",
        "../imagens/banner/Image2025-04-14at20.39.241.webp",
        "../imagens/banner/Image2025-04-14at20.39.242.webp",
        "../imagens/banner/Image2025-04-14at20.39.243.webp"
    ];

    const imagesPng = [
        "../imagens/banner/Image2025-04-14at20.39.16.jpeg",
        "../imagens/banner/Image2025-04-14at20.39.20.jpeg",
        "../imagens/banner/Image2025-04-14at20.39.201.jpeg",
        "../imagens/banner/Image2025-04-14at20.39.202.jpeg",
        "../imagens/banner/Image2025-04-14at20.39.21.jpeg",
        "../imagens/banner/Image2025-04-14at20.39.211.jpeg",
        "../imagens/banner/Image2025-04-14at20.39.22.jpeg",
        "../imagens/banner/Image2025-04-14at20.39.221.jpeg",
        "../imagens/banner/Image2025-04-14at20.39.222.jpeg",
        "../imagens/banner/Image2025-04-14at20.39.23.jpeg",
        "../imagens/banner/Image2025-04-14at20.39.231.jpeg",
        "../imagens/banner/Image2025-04-14at20.39.232.jpeg",
        "../imagens/banner/Image2025-04-14at20.39.233.jpeg",
        "../imagens/banner/Image2025-04-14at20.39.24.jpeg",
        "../imagens/banner/Image2025-04-14at20.39.241.jpeg",
        "../imagens/banner/Image2025-04-14at20.39.242.jpeg",
        "../imagens/banner/Image2025-04-14at20.39.243.jpeg"
    ];

    return (
        <div className="max-w-7xl mx-auto mb-28" id="fotos">
            <p className="text-3xl font-semibold mb-12 mt-16 pt-32 text-secondary">Fotos do empreendimento</p>
            <Slide easing="ease">
                {
                    isWebpSupported()
                        ? imagesWebp.map((slide, index) => {
                            return (
                                <div className="slide" key={slide}>
                                    <div style={{ backgroundImage: `url(${imagesWebp[index]})` }}>
                                        {/* <span>Slide {index + 1}</span> */}
                                    </div>
                                </div>
                            );
                        })
                        : imagesPng.map((slide, index) => {
                            return (
                                <div className="slide" key={slide}>
                                    <div style={{ backgroundImage: `url(${imagesPng[index]})` }}>
                                        {/* <span>Slide {index + 1}</span> */}
                                    </div>
                                </div>
                            );
                        })
                }
            </Slide>
        </div>
    );
}

export default GaleriaFotos;
